import { LIST_PRICE_FORM_MESSAGES, ListPriceFormMessages } from "./list-price-form.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { SKU_FORM_MESSAGES, SkuFormMessages } from "../sku/sku-form.messages";
import { SKU_TABLE_MESSAGES, SkuTableMessages } from "../sku/sku-table.messages.";

export type ListPriceFormPageMessages = ActionButtonMessages &
  SkuTableMessages &
  ListPriceFormMessages &
  SkuFormMessages &
  PopoverMessages &
  SidebarMessages & {
    breadCrumbTitle: string;
    updatePageTitle: string;
    cardTitle: string;

    //Tab Titles
    listPriceTabLabel: string;
    productSkuTabLabel: string;
    kitTabLabel: string;

    salesPriceListErrorToLoad: string;
    salesPriceListNotFoundAlt: string;
  };

export const LIST_PRICE_FORM_PAGE_MESSAGES: ListPriceFormPageMessages = {
  // Page titles
  breadCrumbTitle: "Listas de Preços",
  updatePageTitle: "Editar Lista de Preços",
  cardTitle: "Detalhes do Produto",

  //Tab Titles
  listPriceTabLabel: "Lista de Preços",
  productSkuTabLabel: "SKU",
  kitTabLabel: "KIT",

  salesPriceListErrorToLoad: "Erro ao carregar listas de preços",
  salesPriceListNotFoundAlt: "Lista de preços não encontrada",

  ...SKU_FORM_MESSAGES,
  ...LIST_PRICE_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SKU_TABLE_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...POPOVER_MESSAGES,
};
